export default __webpack_public_path__ + "static/media/calendar.00981229.svg";